<template>
  <div>
    <auto-updates-card-skeleton v-if="phpSettingsLoading" />
    <v-card
      v-else
      elevation="4"
    >
      <v-card-text
        class="d-flex justify-space-between text--gray-darken2"
      >
        <div>
          <h6>{{ $t("heading.instance.advanced.developer.phpSettings.title") }}</h6>
          <p class="mb-0 mt-1">{{ $t("heading.instance.advanced.developer.phpSettings.subtitle") }}</p>
          <AlertSm
            v-if="phpSettingsConfigurable"
            :class="'alert-sm--primary mt-3'"
            :text="$t('heading.instance.advanced.developer.phpVersion.alert')"
          />
          <AlertSm
            v-else
            :class="'alert-sm--primary mt-3'"
            :text="$t('heading.instance.advanced.developer.phpSettings.alert')"
          />
        </div>
        <div class="d-flex align-center">
          <v-btn
            elevation="0"
            class="mt-0 pt-0 v-btn--default"
            :disabled="!phpSettingsConfigurable"
            @click="phpSettingsModalOpen = true"
          >
            <span class="font-weight-bold">{{ $t("button.manage") }}</span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <php-settings-modal
      :open.sync="phpSettingsModalOpen"
      :instance="instance"
      :php-settings="phpSettings"
      :custom="phpSettingsCustom"
    />
  </div>
</template>

<script>
import AlertSm from "@/components/alerts/AlertSm.vue";
import PhpSettingsModal from "@/views/instance/advanced/DeveloperSettings/PhpSettingsModal.vue";
import Api from "@/apis/Api";
import AutoUpdatesCardSkeleton from "@/components/cards/AutoUpdatesCardSkeleton.vue";

export default {
  name: "PhpSettingsCard",
  components: {AutoUpdatesCardSkeleton, PhpSettingsModal, AlertSm},
  props: {
    instance: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      phpSettingsModalOpen: false,
      phpSettingsLoading: false,
      phpSettings: [],
      phpSettingsConfigurable: false,
      phpSettingsCustom: false,
    }
  },
  mounted() {
    this.loadPhpSettingsModal();
  },
  methods: {
    loadPhpSettingsModal() {
      this.phpSettingsLoading = true;
      Api.get(`/server-accounts/${this.instance.hostingId}/domains/${this.instance.domain}/php-settings`)
        .then((response) => {
          this.phpSettings = response.data.directives.map(item => {
            item.editing = false;
            return item;
          })
          this.phpSettingsCustom = response.data.custom_directives;
          this.phpSettingsConfigurable = response.data.configurable;
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.phpSettingsLoading = false;
        });
    },
  }
}
</script>

<style lang="scss" scoped>
.v-card--mobile {
  @media (max-width: 767px) {
    flex-direction: column;
    .v-btn--default {
      margin-top: 16px;
    }
  }
}
</style>